import { PartialMessage } from '@bufbuild/protobuf'
import { StoreCoupon } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/store_coupon_pb'
import { CrossLargeIcon, TagIcon } from '@fingertip/icons'
import { observer } from 'mobx-react-lite'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = {
  form: any
  siteSlug: string
  coupon?: PartialMessage<StoreCoupon>
}

export const BookerCouponForm = observer(({ form, coupon }: Props) => {
  const { t } = useTranslation()
  const [couponCode, setCouponCode] = useState<string>('')

  const setCoupon = useCallback(() => {
    form.setValue('couponCode', couponCode)
  }, [couponCode, form])

  const removeCoupon = useCallback(() => {
    form.setValue('couponCode', undefined)
  }, [form])

  return (
    <div className="mb-4">
      <div className="flex items-end gap-2">
        <Input
          onChange={(c) => {
            setCouponCode(c.target.value)
          }}
          placeholder={t('coupon_code')}
          className="mb-0 mr-3"
        />

        <Button
          type="button"
          variant="secondary"
          disabled={!!coupon?.couponCode}
          onClick={setCoupon}
        >
          {t('apply')}
        </Button>
      </div>

      {coupon && (
        <div className="mt-3">
          <Badge>
            <TagIcon width={16} height={16} />
            <span className="mx-2 text-sm font-semibold">
              {coupon.couponCode}
            </span>

            <button onClick={removeCoupon} type="button">
              <CrossLargeIcon width={16} height={16} />
            </button>
          </Badge>
        </div>
      )}
    </div>
  )
})
